import { Component, inject, input } from '@angular/core';

import { defer } from 'rxjs';

import { CamTenantUrlDisplayerComponent } from '../../../../common/components/tenant-url-displayer/tenant-url-displayer.component';
import { CamProjectsService } from '../../services/projects.service';

@Component({
  imports: [CamTenantUrlDisplayerComponent],
  selector: 'cam-project-tenant-url-displayer',
  templateUrl: './project-tenant-url-displayer.component.html',
})
export class CamProjectTenantUrlDisplayerComponent {
  private _projectService = inject(CamProjectsService);

  projectId = input.required<string>();

  display = input<'button' | 'icon'>('icon');

  route$ = this._projectService.tenantRoute.get$();

  fetch$ = defer(() => this._projectService.fetchTenantRoute$(this.projectId()));
}
